<template>
  <div v-if="label" class="pse-note info pse-compare">
    <i class="pi pi-eye"></i>
    <span><strong>{{ label }}</strong><template v-if="hint">. {{ hint }}</template></span>
  </div>
</template>

<script>
import { compareLabel } from './enquiryLayout'

// The "For MBP review" links open the same pages with ?view=: say which layout is on screen (Mohammed 23/10).
export default {
  name: 'LayoutCompareNote',
  props: { hint: { type: String, default: '' } },
  computed: {
    label() { return compareLabel(this.$route && this.$route.query) }
  }
}
</script>

<style>
@import './sharedEnquiry.css';
</style>
